import React, {Component} from "react";
import Question from '../Question/Question';
import Loading from '../Loading/Loading';
import Results from '../Results/Results'
import unisexImg from '../../question-images/unisex.png'
import femaleImg from '../../question-images/female.jpg'
import maleImg from '../../question-images/male.jpg'
import dayImg from '../../question-images/daytime.jpg'
import eveningImg from '../../question-images/evening.jpg'
import versatileImg from '../../question-images/versatile.jpg'
import confidentImg from '../../question-images/confident.jpg'
import inspiredImg from '../../question-images/inspired.jpg'
import sensualImg from '../../question-images/sensual.jpg'
import elegantImg from '../../question-images/elegant.jpg'
import beachImg from '../../question-images/beach.jpg'
import cityImg from '../../question-images/city.jpg'
import countrysideImg from '../../question-images/country.jpg'
import skiingImg from '../../question-images/skiing.jpg'
import coffeeImg from '../../question-images/coffee.jpg'
import teaImg from '../../question-images/tea.jpg'
import sparklingImg from '../../question-images/sparkling.jpg'
import juiceImg from '../../question-images/juice.jpg'
import cottonImg from '../../question-images/cotton.jpg'
import tweedImg from '../../question-images/tweed.jpg'
import leatherImg from '../../question-images/leather.jpg'
import denimImg from '../../question-images/denim.jpg'
import silkImg from '../../question-images/silk.jpg'
import velvetImg from '../../question-images/velvet.jpg'
import freshImg from '../../question-images/fresh.jpg'
import floralImg from '../../question-images/floral.jpg'
import orientalImg from '../../question-images/oriental.jpg'
import woodyImg from '../../question-images/woody.jpg'
import citrusImg from '../../question-images/citrus.jpg'
import fruityImg from '../../question-images/fruity.jpg'
import herbalImg from '../../question-images/herbal.jpg'
import classicImg from '../../question-images/classic.jpg'
import exoticImg from '../../question-images/exotic.jpg'
import spicyImg from '../../question-images/spiced.jpg'
import sereneImg from '../../question-images/serene.jpg'
import earthyImg from '../../question-images/earthy.jpg'
import cleanImg from '../../question-images/clean.jpg'

export default class QuestionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentQuestion: 0,
      copied: false,
      questions: [
        {
          questionText: "Who is the fragrance for?",
          options: [
            {
              text: "For everyone",
              img: unisexImg,
              weightingName: 'unisex',
            },
            {
              text: "For her",
              img: femaleImg,
              weightingName: 'female',
            },
            {
              text: "For him",
              img: maleImg,
              weightingName: 'male',
            }, 
          ]
        },
        {
          questionText: "Day fragrances can be lighter, evening fragrances heavier. What are you looking for?",
          options: [
            {
              text: "Day",
              img: dayImg,
              weightingName: 'day',
            },
            {
              text: "Evening",
              img: eveningImg,
              weightingName: 'evening',
            },
            {
              text: "Versatile",
              img: versatileImg,
              weightingName: 'versatile',
            }, 
          ]
        },
        {
          questionText: "How would you like to feel when you wear it?",
          options: [
            {
              text: "Confident",
              img: confidentImg,
              weightingName: 'confident',
            },
            {
              text: "Inspired",
              img: inspiredImg,
              weightingName: 'inspired',
            },
            {
              text: "Elegant",
              img: elegantImg,
              weightingName: 'elegant',
            },
            {
              text: "Sensual",
              img: sensualImg,
              weightingName: 'sensual',
            }, 
          ]
        },
        {
          questionText: "Where could you see the fragrance being worn?",
          options: [
            {
              text: "Beach",
              img: beachImg,
              weightingName: 'beach',
            },
            {
              text: "City",
              img: cityImg,
              weightingName: 'city',
            },
            {
              text: "Countryside",
              img: countrysideImg,
              weightingName: 'countryside',
            },
            {
              text: "Skiing",
              img: skiingImg,
              weightingName: 'skiing',
            }, 
          ]
        },
        {
          questionText: "If the fragrance was a beverage, what would it be?",
          options: [
            {
              text: "Coffee",
              img: coffeeImg,
              weightingName: 'coffee',
            },
            {
              text: "tea",
              img: teaImg,
              weightingName: 'tea',
            },
            {
              text: "sparkling",
              img: sparklingImg,
              weightingName: 'sparkling',
            },
            {
              text: "juice",
              img: juiceImg,
              weightingName: 'juice',
            }, 
          ]
        },
        {
          questionText: "If the fragrance was a fabric, what would it be?",
          femaleBranch: true,
          options: [
            {
              text: "cotton",
              img: cottonImg,
              weightingName: 'cotton',
            },
            {
              text: "tweed",
              img: tweedImg,
              weightingName: 'tweed',
            },
            {
              text: "leather",
              img: leatherImg,
              weightingName: 'leather',
            },
            {
              text: "denim",
              img: denimImg,
              weightingName: 'denim',
            }, 
            {
              text: "silk",
              img: silkImg,
              weightingName: 'silk',
            },
            {
              text: "velvet",
              img: velvetImg,
              weightingName: 'velvet',
            }
          ]
        },
        {
          questionText: "What type of fragrance are you looking for?",
          options: [
            {
              text: "fresh",
              img: freshImg,
              weightingName: 'fresh',
            },
            {
              text: "floral",
              img: floralImg,
              weightingName: 'floral',
            },
            {
              text: "oriental",
              img: orientalImg,
              weightingName: 'oriental',
            },
            {
              text: "woody",
              img: woodyImg,
              weightingName: 'woody',
            }
          ]
        },
        {
          questionText: "Which one appeals to you?",
          branching: true,
          options: [
            {
              text: "citrus",
              img: citrusImg,
              weightingName: 'citrus',
              showIf: 'fresh',
            },
            {
              text: "fruity",
              img: fruityImg,
              weightingName: 'fruity',
              showIf: 'fresh',
              hideFor: 'male',
            },
            {
              text: "herbal",
              img: herbalImg,
              weightingName: 'herbal',
              showIf: 'fresh',
              hideFor: 'female',
            },
            {
              text: "classic",
              img: classicImg,
              weightingName: 'classic',
              showIf: 'floral',
            },
            {
              text: "exotic",
              img: exoticImg,
              weightingName: 'exotic',
              showIf: 'floral',
            },
            {
              text: "spicy",
              img: spicyImg,
              weightingName: 'spicy',
              showIf: 'oriental',
            },
            {
              text: "serene",
              img: sereneImg,
              weightingName: 'serene',
              showIf: 'oriental',
            },
            {
              text: "earthy",
              img: earthyImg,
              weightingName: 'earthy',
              showIf: 'woody',
            },
            {
              text: "clean",
              img: cleanImg,
              weightingName: 'clean',
              showIf: 'woody',
            }, 
          ]
        }
      ]
    }
    this.registerAnswer = this.registerAnswer.bind(this);
  }

  componentDidMount() {
    this.props.setTotalQuestions(this.state.questions);
  }

  componentWillReceiveProps(nextProps) {
    const {questions, currentQuestion} = this.state;
    if(currentQuestion === questions.length - 1 && !this.props.winner) {
      const {aggregatedQuestions} = this.props;
      return this.props.getWeighting(aggregatedQuestions);
    }
    const {popQuestion} = nextProps;
    if(popQuestion !== null && popQuestion !== currentQuestion) {
      this.setState({ currentQuestion: popQuestion });
    }
  }

  registerAnswer(answer) {
    const q = this.state.questions[this.state.currentQuestion]; 
    if(window.history) {
      console.log(window.history.state);
      this.props.pushAnswer(answer, q.options);
      let currentState = { q: this.state.currentQuestion, a: answer };
      window.history.replaceState(currentState, `Question ${this.state.currentQuestion + 1}`, `/${this.state.currentQuestion + 1}/${answer}`);
      let stateObj = { q: this.state.currentQuestion + 1 }
      if(this.state.currentQuestion + 1 === this.state.questions.length) {
        window.history.pushState(stateObj, `Results`, `/results`);
        this.props.trackPage(`/results`);
      } else {
        window.history.pushState(stateObj, `Question ${this.state.currentQuestion + 2}`, `/${this.state.currentQuestion + 2}`);
        this.props.trackPage(`/${this.state.currentQuestion + 2}`);
      }
    }
    this.props.setCurrentQuestion(this.state.currentQuestion + 1);
    if(this.state.currentQuestion + 1 === this.state.questions.length) {
      this.setState({ currentQuestion: this.state.currentQuestion + 1 });      
    } else {
      setTimeout( () => {
        this.setState({ currentQuestion: this.state.currentQuestion + 1 });
      }, 600);
    }
  }

  render() {
    const {questions, currentQuestion} = this.state;
    const {status, winner, results, aggregatedQuestions} = this.props;``
    if(questions[currentQuestion] && questions[currentQuestion].branching) {
      questions[currentQuestion].options = questions[currentQuestion].options.filter( (option) => aggregatedQuestions.includes(option.showIf));
      questions[currentQuestion].options = questions[currentQuestion].options.filter( (option) => !aggregatedQuestions.includes(option.hideFor));
    }
    return (
      <div className="questionsList">
        { currentQuestion === questions.length && status === "LOADING" ?
          <div className="results">
            <Loading />
          </div>
        : currentQuestion === questions.length && status === "SUCCESS" ?
          <Results
            winner={winner}
            otherResults={results.slice(1,4)}
            basket={this.props.basket}
            addToBasket={this.props.addToBasket}
            removeFromBasket={this.props.removeFromBasket}
            setActiveResult={this.props.setActiveResult}
            copied={this.state.copied}
            setCopied={ () => { this.setState({ copied: true }); setTimeout( () => this.setState({ copied: false }), 2000) } }
            trackEvent={this.props.trackEvent}
          />
        : currentQuestion < questions.length ?
          <Question
            {...questions[currentQuestion]}
            onAnswerClick={this.registerAnswer}
            aggregatedQuestions={this.props.aggregatedQuestions}
            trackEvent={this.props.trackEvent}
            questionNumber={currentQuestion + 1}
          />
        : null }
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/QuestionList/QuestionList.js